import React from 'react'
import { Outlet } from 'react-router';

function NoAuthLayout() {
	return (
		<>
			<Outlet />
		</>
	)
}

export default NoAuthLayout